import { Box, Tab, Tabs } from "@mui/material";
import { dbDataStore, triggersStore, userStore } from "../../store/Store";
import { useState } from "react";
import { a11yProps, CustomTabPanel } from "../../components/TabPanels";

// hooks
import useGetFetch from "../../hooks/useGetFetch";

// components
import ErrorDisplay from "../../components/ErrorDisplay";
import Loading from "../../components/Loading";

// assets
import Add from "../../assets/add.svg"
import DisplayList from "../../components/DisplayList";

export default function RateSheetTabs() {
  const setRateSheetData = dbDataStore((data) => data.setRateSheetData);
  const rateSheetData = dbDataStore((data) => data.rateSheetData);
  const setTieredRateSheets = dbDataStore((data) => data.setTieredRateSheets);
  const tieredRateSheets = dbDataStore((data) => data.tieredRateSheets);
  const currentCompany = userStore((data) => data.currentCompany)
  const setRateSheetTrigger = triggersStore((data) => data.setRateSheetTrigger)
  const rateSheetTrigger = triggersStore((data) => data.rateSheetTrigger)
  const setTieredRateSheetTrigger = triggersStore((data) => data.setTieredRateSheetTrigger)
  const tieredRateSheetTrigger = triggersStore((data) => data.tieredRateSheetTrigger)

  // local
  const [value, setValue] = useState(0);
  const [isTiered, setIsTiered] = useState(false);

  const { isPending, error } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/rate-sheets?is_tiered=false`,
    setRateSheetData
  );
  
  const { isPending: tierPending, error: tierError } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/rate-sheets?is_tiered=true`,
    setTieredRateSheets
  );

  const handleChange = (_, newValue) => {
    setValue(newValue);
    if (newValue === 0) {
      setIsTiered(false);
    } else {
      setIsTiered(true);
    }
  };
  
  if (isPending || tierPending) {
    return <Loading />;
  }
  if (error || tierError) {
    return <ErrorDisplay code={500} message={"Something went wrong"} />;
  }
  return (
    <>
      <Box
        sx={{
          width: "100%",
          margin: "20px 0 0 0",
          padding: "0",
        }}
      >
        <div className="d-flex justify-content-between project-header">
          <Box sx={{ padding: "0" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                label="Standard"
                {...a11yProps(1)}
                sx={{
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              />
              <Tab
                label="Tiered"
                {...a11yProps(0)}
                sx={{
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              />
            </Tabs>
          </Box>
          {!isTiered && currentCompany.full_access ? (
            <img
              src={Add}
              alt="add"
              className="project-delete-image"
              onClick={() => setRateSheetTrigger(true)}
            />
          ): (<img
              src={Add}
              alt="add"
              className="project-delete-image"
              onClick={() => setTieredRateSheetTrigger(true)}
            />)}
        </div>
        {currentCompany.full_access && (
          <>
            <CustomTabPanel value={value} index={0}>
              <DisplayList 
                coll={'Standard Freight Rate Sheets'}
                docs={rateSheetData}
                err={error}
                trigger={rateSheetTrigger}
                setTrigger={setRateSheetTrigger}
                url={`${process.env.REACT_APP_BACKEND}/pc/rate-sheets?is_tiered=false`}
                setState={setRateSheetData}
                doNotDisplayTitle={true}
                statusToggle={true}
                setDeleteState={setRateSheetData}
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <DisplayList 
                coll={'Tiered Freight Rate Sheets'}
                docs={tieredRateSheets}
                err={error}
                trigger={tieredRateSheetTrigger}
                setTrigger={setTieredRateSheetTrigger}
                url={`${process.env.REACT_APP_BACKEND}/pc/rate-sheets?is_tiered=true`}
                setState={setTieredRateSheets}
                doNotDisplayTitle={true}
                statusToggle={true}
                setDeleteState={setTieredRateSheets}
              />
            </CustomTabPanel>
          </>
        )}
      </Box>
    </>
  );
}
